/**
 * Format a positive duration at minutes resolution: "3h 12m", "45m", or
 * "1d 6h" if it ever exceeds a day (the rolling 24h window normally caps it at
 * 24h). Used by the daily-limit dialog's countdown.
 */
export function formatRemaining(ms: number): string {
  const totalMinutes = Math.ceil(ms / 60_000);
  const days = Math.floor(totalMinutes / 1440);
  const hours = Math.floor((totalMinutes % 1440) / 60);
  const minutes = totalMinutes % 60;
  if (days > 0) return hours > 0 ? `${days}d ${hours}h` : `${days}d`;
  if (hours > 0) return minutes > 0 ? `${hours}h ${minutes}m` : `${hours}h`;
  return `${minutes}m`;
}
